import { useState } from 'react'
import { Toast } from 'react-vant'
import { APIWeb } from '@/api'
import { useTransactionRefresh } from '@/hooks'
import type { KycFormData } from './useKycForm'
import { useTranslation } from 'react-i18next'
export enum KycStep {
  BaseInfo = 'baseInfo',
  Identification = 'identification',
  SubmitSuccess = 'submitSuccess',
  AuditPass = 'auditPass'
}

export const useKycSubmit = (
  formData: KycFormData,
  validateBaseInfoForm: () => boolean,
  validateIdentificationForm: () => { isValid: boolean; message: string }
) => {
  const [currentStep, setCurrentStep] = useState(KycStep.BaseInfo)
  const [loading, setLoading] = useState(false)
  const { refreshAfterTransaction } = useTransactionRefresh()
  const { t } = useTranslation()
  const handleNext = () => {
    if (validateBaseInfoForm()) {
      setCurrentStep(KycStep.Identification)
    }
  }

  // 处理提交审核
  const handleSubmit = async () => {
    // 先校验基本信息
    const baseInfoValid = validateBaseInfoForm()
    if (!baseInfoValid) {
      Toast.info({
        position: 'top',
        message: t('请完善基本信息'),
      })
      return
    }

    // 再校验证件信息
    const identificationResult = validateIdentificationForm()
    if (!identificationResult.isValid) {
      Toast.info({
        position: 'top',
        message: identificationResult.message,
      })
      return
    }

    setLoading(true)
    // 提交审核
    try {
      const params: ApplyKycRequest = {
        ...formData,
        birthday: `${formData.birthYear}-${formData.birthMonth}-${formData.birthDay}`,
        address: '',
        identity_type: formData.identity_type as IdentityType,
        passport: formData.passport ?? undefined,
        id_card: {
          front: formData.id_card.front ?? undefined,
          back: formData.id_card.back ?? undefined,
          hand_hold: formData.id_card.hand_hold ?? undefined,
        },
      }
      await APIWeb.applyKyc(params)
      Toast.success({
        position: 'middle',
        message: t('提交成功'),
      })
      // 刷新用户信息状态
      await refreshAfterTransaction()
      // 所有校验通过，进入成功页面
      setCurrentStep(KycStep.SubmitSuccess)
    } finally {
      setLoading(false)
    }
  }

  return {
    currentStep,
    setCurrentStep,
    loading,
    handleNext,
    handleSubmit
  }
}